const documents = [
  {
    title: "Anunț – rechizite școlare",
    file: "Anunț - rechizite școlare.pdf",
    type: "pdf",
  },
  {
    title: "Cerere rechizite 2026–2027 – Word",
    file: "Cerere rechizite 2026-2027.docx",
    type: "docx",
  },
  {
    title: "Cerere rechizite 2026–2027 – PDF",
    file: "Cerere rechizite 2026-2027.pdf",
    type: "pdf",
  },
  {
    title: "Declarație pe propria răspundere – Word",
    file: "declaratie pe propria răspundere.docx",
    type: "docx",
  },
  {
    title: "Declarație pe propria răspundere – PDF",
    file: "declaratie pe propria răspundere.pdf",
    type: "pdf",
  },
];

export default function RechiziteScolarePage() {
  const basePath = "/educatie/rechiziteScolare/";

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <div className="bg-white p-6 rounded shadow space-y-4">
          {documents.map((document) => {
            const documentUrl =
              basePath + encodeURIComponent(document.file);

            return (
              <div
                key={document.file}
                className="flex flex-col gap-3 border rounded-md p-4 sm:flex-row sm:items-center sm:justify-between"
              >
                <span className="font-medium text-gray-800">
                  {document.title}
                </span>

                {document.type === "pdf" ? (
                  <a
                    href={documentUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block rounded bg-blue-600 px-4 py-2 text-center text-white hover:bg-blue-700"
                  >
                    Deschide PDF
                  </a>
                ) : (
                  <a
                    href={documentUrl}
                    download
                    className="inline-block rounded bg-green-600 px-4 py-2 text-center text-white hover:bg-green-700"
                  >
                    Descarcă DOCX
                  </a>
                )}
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
}